/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountDataOrganizationSchema } from "../accountDataOrganizationSchema.ts";
import { errorResponseSchema } from "../errorResponseSchema.ts";
import { z } from "zod";

export const getUserOrganizationsHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description La liste des organisations est retournée avec succès.
 */
export const getUserOrganizations200Schema = z.array(z.lazy(() => accountDataOrganizationSchema))

/**
 * @description Réponse d\'erreur standard
 */
export const getUserOrganizations500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const getUserOrganizationsQueryResponseSchema = z.lazy(() => getUserOrganizations200Schema)